import env from '../env';
import { sendPost } from './dataUtilities';

const POST_SAVE_ADDITIONAL_CHOICES_PATH = '/new-members/checkout/self/active';

const postSaveAdditionalChoices = () => sendPost(`${env.newMemberApiUrl}${POST_SAVE_ADDITIONAL_CHOICES_PATH}`, {}, {});

export { postSaveAdditionalChoices, POST_SAVE_ADDITIONAL_CHOICES_PATH };
